var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VouchCategory',{attrs:{"title":"Für die ganze Familie","isMinimal":true,"ids":_vm.vouchers,"showButton":false,"hideTitle":true,"isPlugin":true}})}
var staticRenderFns = []

export { render, staticRenderFns }